import React, { FC } from 'react';
import { NumberInput, minValue, useTranslate } from 'react-admin';
import { H3 } from '~/components';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { l, validateInteger } from '~/utils/solutions';

interface ObjectDraftsFormProps {
  keyName: string;
}

export const ObjectDraftsForm: FC<ObjectDraftsFormProps> = ({ keyName }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));

  return (
    <>
      <H3 topSpacing={0} bottomSpacing={2}>
        {t('objectDraftsTitle')}
      </H3>
      <NumberInput
        label={t('objectDraftsNotificationDelay')}
        source={`${keyName}.settings.notificationDelaySeconds`}
        min={0}
        step={1}
        validate={[minValue(1), validateInteger]}
        className={classes.inputWidth}
      />
      <NumberInput
        label={t('objectDraftsExpirationTtl')}
        source={`${keyName}.settings.expirationTtlSeconds`}
        min={0}
        step={1}
        validate={[minValue(1), validateInteger]}
        className={classes.inputWidth}
      />
      <NumberInput
        label={t('objectDraftsBatchSize')}
        source={`${keyName}.settings.batchSize`}
        min={1}
        step={1}
        validate={[minValue(1), validateInteger]}
        className={classes.inputWidth}
      />
    </>
  );
};
